import { useEffect } from 'react'
import { assertDefined } from 'web/utils/utils'

export function useOutsideClick<T extends HTMLElement | null>(
    { ref, onOutsideClick }: {
        ref: React.MutableRefObject<T>
        onOutsideClick: () => void
    }
) {
    useEffect(() => {
        function handleClickOutside(event: any) {

            if (ref.current != null) {
                const parent = ref.current
                assertDefined(parent)
                const children = [...parent.querySelectorAll('*')]

                const targetFound = [
                    parent,
                    ...children,
                ].includes(event.target)

                if (!targetFound) {
                    onOutsideClick()
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [ref, onOutsideClick])
}
